import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import history from '../../config/history';
import formatDate from '../../services/formatDate';
import { handleError } from '../user';
import constants from '../../services/constants';
import { toastr } from 'react-redux-toastr';

export const setGlobalUserErrors = createAction('SET_GLOBAL_USER_ERRORS');
export const setGlobalUserDisplay = createAction('SET_GLOBAL_USER_DISPLAY');
export const setGlobalUserResumeDisplay = createAction('SET_GLOBAL_USER_RESUME_DISPLAY');
export const setGlobalUserResumeDisplayMsg = createAction('SET_GLOBAL_USER_RESUME_DISPLAY_MSG');
export const setGlobalUserMessage = createAction('SET_GLOBAL_USER_MESSAGE');
export const setGlobalUserFullName = createAction('SET_GLOBAL_USER_FULL_NAME');
export const setGlobalUserFirstName = createAction('SET_GLOBAL_USER_FIRST_NAME');
export const setGlobalUserLastName = createAction('SET_GLOBAL_USER_LAST_NAME');
export const setGlobalUserEmail = createAction('SET_GLOBAL_USER_EMAIL');
export const setGlobalUserAddres = createAction('SET_GLOBAL_USER_ADDRESS');
export const setGlobalUserAddress2 = createAction('SET_GLOBAL_USER_ADDRESS2');
export const setGlobalUserCity = createAction('SET_GLOBAL_USER_CITY');
export const setGlobalUserState = createAction('SET_GLOBAL_USER_STATE');
export const setGlobalUserZipcode = createAction('SET_GLOBAL_USER_ZIPCODE');
export const setGlobalUserPrimaryPhone = createAction('SET_GLOBAL_USER_PRIMARY_PHONE');
export const setGlobalUserAlternatePhone = createAction('SET_GLOBAL_USER_ALTERNATE_PHONE');
export const setGlobalUserProfileImgPath = createAction('SET_GLOBAL_USER_PROFILE_IMG_PATH');
export const setGlobalUserProfileFileType = createAction('SET_GLOBAL_USER_PROFILE_FILE_TYPE');
export const setGlobalUserNewPassword = createAction('SET_GLOBAL_USER_NEW_PASSWORD');
export const setGlobalUserConfirmPassword = createAction('SET_GLOBAL_USER_CONFIRM_PASSWORD');

export const setGlobalUserType = createAction('SET_GLOBAL_USER_TYPE');
export const setGlobalUserRole = createAction('SET_GLOBAL_USER_ROLE');
export const setGlobalYearsOfExperience = createAction('SET_GLOBAL_YEARS_OF_EXPERIENCE');
export const setGlobalYearsOfExperienceID = createAction('SET_GLOBAL_YEARS_OF_EXPERIENCE_ID');
export const setGlobalUserOrg = createAction('SET_GLOBAL_USER_ORG');
export const setGlobalUserLoc = createAction('SET_GLOBAL_USER_LOC');
export const setGlobalUserDept = createAction('SET_GLOBAL_USER_DEPT');
export const setGlobalUserNewOrg = createAction('SET_GLOBAL_USER_NEWORG');
export const setGlobalUserNewLoc = createAction('SET_GLOBAL_USER_NEWLOC');
export const setGlobalUserNewInc = createAction('SET_GLOBAL_USER_NEWINC');

export const setGlobalUserNewDept = createAction('SET_GLOBAL_USER_NEWDEPT');
export const setGlobalUserNewEmpType = createAction('SET_GLOBAL_USER_NEWEMPTYPE');

export const setGlobalUserNewNursePool = createAction('SET_GLOBAL_USER_NEW_NURSE_POOL');

export const setGlobalUserNote = createAction('SET_GLOBAL_USER_NOTE');
export const setGlobalUserResumeFile = createAction('SET_GLOBAL_USER_RESUME_ID');
export const setGlobalUserResumeFileName = createAction('SET_GLOBAL_USER_RESUME_FILE_NAME');
export const setGlobalUserResumeFileId = createAction('SET_GLOBAL_USER_RESUME_FILE_ID');
export const setGlobalUserEmployment = createAction('SET_GLOBAL_USER_EMPLOYMENT');
export const setGlobalUserID = createAction('SET_GLOBAL_USER_ID');
export const setUserCareSetting = createAction('SET_USER_CARE_SETTING');
export const setGlobalUnitCustomerID = createAction('SET_GLOBAL_UNIT_CUSTOMER_ID');
export const setGlobalUserRequirements = createAction('SET_GLOBAL_USER_REQUIREMENTS');
export const setRequirementsSearchList = createAction('SET_GLOBAL_USER_SEARCH_REQUIREMENTS');
export const setGlobalUserJobHistories = createAction('SET_GLOBAL_USER_JOB_HISTORIES');
export const resetGlobalUser = createAction('REST_GLOBAL_USER');
export const setGlobalUserIsAdmin = createAction('SET_GLOBAL_USER_IS_ADMIN');
export const setGlobalUserIsSupervisor = createAction('SET_GLOBAL_USER_IS_SUPERVISOR');
export const setGlobalUserIsShiftManager = createAction('SET_GLOBAL_USER_IS_SHIFT_MANAGER');
export const setGlobalUserIsRateIncrease = createAction('SET_GLOBAL_USER_IS_RATE_INCREASE');
export const setGlobalUserIsNurse = createAction('SET_GLOBAL_USER_IS_NURSE');
export const setGlobalUserIsTestUser = createAction('SET_GLOBAL_USER_IS_TEST_USER');
export const setGlobalUserStatus = createAction('SET_GLOBAL_USER_STATUS');
export const setGlobalUserOrgs = createAction('SET_GLOBAL_USER_ORGS');
export const setGlobalUserFormState = createAction('SET_GLOBAL_USER_FORM_STATE');
export const setGlobalUserReqDetails = createAction('SET_GLOBAL_USER_REQ_DETAILS');
export const setAccountRating = createAction('SET_NURSE_RATING');
export const setuserPreferenceStatus = createAction('SET_USER_PREFER_STATUS');
export const setNurseHistoryList = createAction('SET_NURSE_HISTORY_LIST');
export const setAcceptedAppliedShifts = createAction('SET_ACCEPTED_APPLIED_SHIFTS');
export const setMediationCount = createAction('SET_MEDIATION_COUNT');
export const setCompltShiftCount = createAction('SET_COMPLT_SHIFTCOUNT');
export const setPasswrdToViewPin = createAction('SET_PASSWORD_TO_VIEWPIN');
export const setAutoGeneratedPinPopup = createAction('SET_AUTOGENERATEPINPOPUP');
export const setAddUserAutoGenerateCode = createAction('SET_ADDUSERAUTO_GENERATECODE');
export const setGlobalUserDetail = createAction('SET_GLOBAL_USER_DETAIL');
export const setIsLoadingRequirement = createAction('SET_IS_LOADING_REQUIREMENT');
export const setGlobalUserAcceptCount = createAction('SET_GLOBAL_USER_ACCEPT_COUNT');
export const setGlobalUserCalloutCount = createAction('SET_GLOBAL_USER_CALLOUT_COUNT');
export const setGlobalUserCalloutRate = createAction('SET_GLOBAL_USER_CALLOUT_RATE');
export const setGlobalUserCalloutYearlyCount = createAction('SET_GLOBAL_USER_CALLOUT_YEARLY_COUNT');
export const setGlobalUserSTATCashStatus = createAction('SET_GLOBAL_USER_STATCASH_STATUS');
export const setGlobalUserIsAboveGold = createAction('SET_GLOBAL_USER_IS_ABOVE_GOLD');
export const setGlobalUserIsAboveSilver = createAction('SET_GLOBAL_USER_IS_ABOVE_SILVER');

export const setSuspendEndDate = createAction('SET_SUSPEND_END_DATE');
export const setSuspendEndTime = createAction('SET_SUSPEND_END_TIME');
export const setIsNewSuspendFlow = createAction('SET_IS_NEW_SUSPEND_FLOW');
export const setDefaultSuspendDate = createAction('SET_DEFAULT_SUSPEND_DATE');
export const setDefaultSuspendStartDate = createAction('SET_DEFAULT_SUSPEND_START_DATE');

export const setUserDNRList = createAction('SET_USER_DNR_LIST');
export const setUserClinicalLisences = createAction('SET_USER_CLINICAL_LICENSES');

export const setCurrentStartTime = createAction('SET_CURRENT_START_TIME');
export const setCurrentEndTime = createAction('SET_CURRENT_END_TIME');
export const setNurseInstantAcceptToggleStatus = createAction('SET_INSTANT_ACCEPT_TOGGLE_STATUS');
export const setTheBeatUserToggleStatus = createAction('SET_THE_BEAT_TOGGLE_STATUS');
export const setBeatAdminToggleStatus = createAction('SET_BEAT_ADMIN_TOGGLE_STATUS');
export const setGlobalUserNursePool = createAction('SET_GLOBAL_USER_NURSE_POOL');
export const setGlobalUserExcusedCalloutCount = createAction('SET_GLOBAL_USER_EXCUSED_CALLOUT_COUNT');
export const setGlobalUserNCNSCalloutCount = createAction('SET_GLOBAL_USER_NCNS_CALLOUT_COUNT');
export const setGlobalUserNCNSYearlyCount = createAction('SET_GLOBAL_USER_NCNS_YEARLY_COUNT');
export const setGlobalUserWorkedYearlyCount = createAction('SET_GLOBAL_USER_WORKED_YEARLY_COUNT');
export const setGlobalUserAcceptYearlyCount = createAction('SET_GLOBAL_USER_ACCEPT_YEARLY_COUNT');
export const setGlobalUserActivatedOn = createAction('SET_GLOBAL_USER_ACTIVATED_ON');
export const setGlobalUserEightHoursCalloutCount = createAction('SET_GLOBAL_USER_EIGHT_HOURS_CALLOUT_COUNT');
export const setFetchingShiftHistory = createAction('SET_FETCHING_SHIFT_HISTORY');
export const setGlobalUserReferralName = createAction('SET_REFERRAL_NAME');
export const setGlobalUserUTMSource = createAction('SET_UTM_SOURCE');
export const setGlobalUserReferralEmail = createAction('SET_REFERRAL_EMAIL');
export const setGlobalUserEmergencyContactName = createAction('SET_EMERGENCY_CONTACT_NAME');
export const setGlobalUserEmergencyContactReleationship = createAction('SET_EMERGENCY_CONTACT_RELATIONSHIP');
export const setGlobalUserEmergencyContactPhone = createAction('SET_EMERGENCY_CONTACT_PHONE');

export const setPersonalDetailsEdit = createAction('SET_PERSONAL_DETAILS_EDIT');

const initialState = {
	acceptCount: 0,
	acceptedAppliedShifts: {},
	acceptyearlyCount: 0,
	activatedOn: '',
	address: '',
	address2: '',
	addUserAutoGenerateCode: Math.floor(1000 + Math.random() * 9000).toString(),
	alternatePhoneNumber: '',
	autoGeneratedPinPopup: false,
	calloutCount: 0,
	calloutRate: 0,
	calloutyearlyCount: 0,
	city: '',
	compltShiftCount: 0,
	confirmPassword: '',
	current_suspend_end_date: '',
	current_suspend_start_date: '',
	default_suspend_date: '',
	default_suspend_start_date: '',
	dept_id: '',
	display: 'none',
	dnrList: [],
	eightHRcalloutCount: 0,
	email: '',
	emergency_contact_name: '',
	emergency_contact_phone: '',
	emergency_contact_relationship: '',
	employment: '',
	errors: {},
	excusedcalloutCount: 0,
	file_type: '',
	firstName: '',
	formSaved: true,
	fullName: '',
	globalUserDetail: {},
	is_above_gold: false,
	is_admin: false,
	is_instant_accept_nurse_enable: false,
	is_new_suspend_flow: false,
	is_nurse: false,
	is_supervisor: false,
	is_test_user: false,
	isAboveSilver: false,
	isBeatAdmin: false,
	isFetchingShiftHistory: false,
	isLoadingRequirement: false,
	isRateIncrease: false,
	isShiftManager: false,
	isTheBeatUserEnable: false,
	lastName: '',
	loc_id: '',
	mediationCount: 0,
	message: '',
	ncnscalloutsCount: 0,
	ncnsYearlyCount: 0,
	new_dept_id: '',
	new_emp_type: '',
	new_inc: '',
	new_loc_id: '',
	new_nurse_pool: null,
	new_org_id: '',
	newPassword: '',
	note: '',
	nurse_pool: null,
	nurse_shiftHis: [],
	org_id: '',
	passwrdToViewPin: '',
	personalDetailsEdit: false,
	primaryPhoneNumber: '',
	profileImagePath: '',
	referral_email: '',
	referral_name: '',
	requirementDetails: [],
	requirementSearchList: [],
	resume_display: 'none',
	resume_display_msg: '',
	resume_file_id: -1,
	resume_file_name: '',
	resume_path: '',
	role_id: '',
	statcash_status: 0,
	state: '',
	status: '',
	suspendEndDate: '',
	suspendEndTime: '',
	type: '1',
	unit_customer_id: null,
	user_care_settings: [],
	user_id: '',
	user_preference_status: false,
	user_rating: 0,
	userJobHistories: [],
	userOrgs: [],
	userRequirements: [],
	utm_source: '',
	workedYearlyCount: 0,
	years_of_experience: null,
	years_of_experience_id: null,
	zipcode: ''
};

export default handleActions(
	{
		REST_GLOBAL_USER: () => initialState,
		SET_ACCEPTED_APPLIED_SHIFTS: (state, action) => ({ ...state, acceptedAppliedShifts: action.payload }),
		SET_ADDUSERAUTO_GENERATECODE: (state, action) => ({ ...state, addUserAutoGenerateCode: action.payload }),
		SET_AUTOGENERATEPINPOPUP: (state, action) => ({ ...state, autoGeneratedPinPopup: action.payload }),
		SET_BEAT_ADMIN_TOGGLE_STATUS: (state, action) => ({ ...state, isBeatAdmin: action.payload }),
		SET_COMPLT_SHIFTCOUNT: (state, action) => ({ ...state, compltShiftCount: action.payload }),
		SET_CURRENT_END_TIME: (state, action) => ({ ...state, current_suspend_end_date: action.payload }),
		SET_CURRENT_START_TIME: (state, action) => ({ ...state, current_suspend_start_date: action.payload }),
		SET_DEFAULT_SUSPEND_DATE: (state, action) => ({ ...state, default_suspend_date: action.payload }),
		SET_DEFAULT_SUSPEND_START_DATE: (state, action) => ({ ...state, default_suspend_start_date: action.payload }),
		SET_EMERGENCY_CONTACT_NAME: (state, action) => ({ ...state, emergency_contact_name: action.payload }),
		SET_EMERGENCY_CONTACT_PHONE: (state, action) => ({ ...state, emergency_contact_phone: action.payload }),
		SET_EMERGENCY_CONTACT_RELATIONSHIP: (state, action) => ({
			...state,
			emergency_contact_relationship: action.payload
		}),
		SET_FETCHING_SHIFT_HISTORY: (state, action) => ({ ...state, isFetchingShiftHistory: action.payload }),
		SET_GLOBAL_UNIT_CUSTOMER_ID: (state, action) => ({ ...state, unit_customer_id: action.payload }),
		SET_GLOBAL_USER_ACCEPT_COUNT: (state, action) => ({ ...state, acceptCount: action.payload }),
		SET_GLOBAL_USER_ACCEPT_YEARLY_COUNT: (state, action) => ({ ...state, acceptyearlyCount: action.payload }),
		SET_GLOBAL_USER_ACTIVATED_ON: (state, action) => ({ ...state, activatedOn: action.payload }),
		SET_GLOBAL_USER_ADDRESS: (state, action) => ({
			...state,
			address: action.payload
		}),
		SET_GLOBAL_USER_ADDRESS2: (state, action) => ({
			...state,
			address2: action.payload
		}),
		SET_GLOBAL_USER_ALTERNATE_PHONE: (state, action) => ({ ...state, alternatePhoneNumber: action.payload }),
		SET_GLOBAL_USER_CALLOUT_COUNT: (state, action) => ({ ...state, calloutCount: action.payload }),
		SET_GLOBAL_USER_CALLOUT_RATE: (state, action) => ({ ...state, calloutRate: action.payload }),
		SET_GLOBAL_USER_CALLOUT_YEARLY_COUNT: (state, action) => ({ ...state, calloutyearlyCount: action.payload }),
		SET_GLOBAL_USER_CITY: (state, action) => ({
			...state,
			city: action.payload
		}),
		SET_GLOBAL_USER_CONFIRM_PASSWORD: (state, action) => ({ ...state, confirmPassword: action.payload }),
		SET_GLOBAL_USER_DEPT: (state, action) => ({ ...state, dept_id: action.payload }),
		SET_GLOBAL_USER_DETAIL: (state, action) => ({ ...state, globalUserDetail: action.payload }),
		SET_GLOBAL_USER_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_GLOBAL_USER_EIGHT_HOURS_CALLOUT_COUNT: (state, action) => ({ ...state, eightHRcalloutCount: action.payload }),
		SET_GLOBAL_USER_EMAIL: (state, action) => ({ ...state, email: action.payload }),
		SET_GLOBAL_USER_EMPLOYMENT: (state, action) => ({ ...state, employment: action.payload }),
		SET_GLOBAL_USER_EXCUSED_CALLOUT_COUNT: (state, action) => ({ ...state, excusedcalloutCount: action.payload }),
		SET_GLOBAL_USER_FIRST_NAME: (state, action) => ({ ...state, firstName: action.payload }),
		SET_GLOBAL_USER_FORM_STATE: (state, action) => ({ ...state, formSaved: action.payload }),
		SET_GLOBAL_USER_FULL_NAME: (state, action) => ({ ...state, fullName: action.payload }),
		SET_GLOBAL_USER_ID: (state, action) => ({ ...state, user_id: action.payload }),
		SET_GLOBAL_USER_IS_ABOVE_GOLD: (state, action) => ({ ...state, is_above_gold: action.payload >= constants.Gold }),
		SET_GLOBAL_USER_IS_ABOVE_SILVER: (state, action) => ({
			...state,
			isAboveSilver: action.payload >= constants.Silver
		}),
		SET_GLOBAL_USER_IS_ADMIN: (state, action) => ({ ...state, is_admin: action.payload }),
		SET_GLOBAL_USER_IS_NURSE: (state, action) => ({ ...state, is_nurse: action.payload }),
		SET_GLOBAL_USER_IS_RATE_INCREASE: (state, action) => ({
			...state,
			isRateIncrease: action.payload
		}),
		SET_GLOBAL_USER_IS_SHIFT_MANAGER: (state, action) => ({
			...state,
			isShiftManager: action.payload
		}),
		SET_GLOBAL_USER_IS_SUPERVISOR: (state, action) => ({ ...state, is_supervisor: action.payload }),
		SET_GLOBAL_USER_IS_TEST_USER: (state, action) => ({ ...state, is_test_user: action.payload }),
		SET_GLOBAL_USER_JOB_HISTORIES: (state, action) => ({ ...state, userJobHistories: action.payload }),
		SET_GLOBAL_USER_LAST_NAME: (state, action) => ({ ...state, lastName: action.payload }),
		SET_GLOBAL_USER_LOC: (state, action) => ({ ...state, loc_id: action.payload }),
		SET_GLOBAL_USER_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_GLOBAL_USER_NCNS_CALLOUT_COUNT: (state, action) => ({ ...state, ncnscalloutsCount: action.payload }),
		SET_GLOBAL_USER_NCNS_YEARLY_COUNT: (state, action) => ({ ...state, ncnsYearlyCount: action.payload }),
		SET_GLOBAL_USER_NEW_NURSE_POOL: (state, action) => ({ ...state, new_nurse_pool: action.payload }),
		SET_GLOBAL_USER_NEW_PASSWORD: (state, action) => ({ ...state, newPassword: action.payload }),
		SET_GLOBAL_USER_NEWDEPT: (state, action) => ({ ...state, new_dept_id: action.payload }),
		SET_GLOBAL_USER_NEWEMPTYPE: (state, action) => ({ ...state, new_emp_type: action.payload }),
		SET_GLOBAL_USER_NEWINC: (state, action) => ({ ...state, new_inc: action.payload }),
		SET_GLOBAL_USER_NEWLOC: (state, action) => ({ ...state, new_loc_id: action.payload }),
		SET_GLOBAL_USER_NEWORG: (state, action) => ({ ...state, new_org_id: action.payload }),
		SET_GLOBAL_USER_NOTE: (state, action) => ({ ...state, note: action.payload }),
		SET_GLOBAL_USER_NURSE_POOL: (state, action) => ({ ...state, nurse_pool: action.payload }),
		SET_GLOBAL_USER_ORG: (state, action) => ({ ...state, org_id: action.payload }),
		SET_GLOBAL_USER_ORGS: (state, action) => ({ ...state, userOrgs: action.payload }),
		SET_GLOBAL_USER_PRIMARY_PHONE: (state, action) => ({ ...state, primaryPhoneNumber: action.payload }),
		SET_GLOBAL_USER_PROFILE_FILE_TYPE: (state, action) => ({ ...state, file_type: action.payload }),
		SET_GLOBAL_USER_PROFILE_IMG_PATH: (state, action) => ({ ...state, profileImagePath: action.payload }),
		SET_GLOBAL_USER_REQ_DETAILS: (state, action) => ({ ...state, requirementDetails: action.payload }),
		SET_GLOBAL_USER_REQUIREMENTS: (state, action) => ({ ...state, userRequirements: action.payload }),
		SET_GLOBAL_USER_RESUME_DISPLAY: (state, action) => ({ ...state, resume_display: action.payload }),
		SET_GLOBAL_USER_RESUME_DISPLAY_MSG: (state, action) => ({ ...state, resume_display_msg: action.payload }),
		SET_GLOBAL_USER_RESUME_FILE_ID: (state, action) => ({ ...state, resume_file_id: action.payload }),
		SET_GLOBAL_USER_RESUME_FILE_NAME: (state, action) => ({ ...state, resume_file_name: action.payload }),
		SET_GLOBAL_USER_RESUME_ID: (state, action) => ({ ...state, resume_path: action.payload }),
		SET_GLOBAL_USER_ROLE: (state, action) => ({ ...state, role_id: action.payload }),
		SET_GLOBAL_USER_SEARCH_REQUIREMENTS: (state, action) => ({ ...state, requirementSearchList: action.payload }),
		SET_GLOBAL_USER_STATCASH_STATUS: (state, action) => ({ ...state, statcash_status: action.payload }),
		SET_GLOBAL_USER_STATE: (state, action) => ({ ...state, state: action.payload }),
		SET_GLOBAL_USER_STATUS: (state, action) => ({ ...state, status: action.payload }),
		SET_GLOBAL_USER_TYPE: (state, action) => ({ ...state, type: action.payload }),
		SET_GLOBAL_USER_WORKED_YEARLY_COUNT: (state, action) => ({ ...state, workedYearlyCount: action.payload }),
		SET_GLOBAL_USER_ZIPCODE: (state, action) => ({ ...state, zipcode: action.payload }),
		SET_GLOBAL_YEARS_OF_EXPERIENCE: (state, action) => ({ ...state, years_of_experience: action.payload }),
		SET_GLOBAL_YEARS_OF_EXPERIENCE_ID: (state, action) => ({ ...state, years_of_experience_id: action.payload }),
		SET_INSTANT_ACCEPT_TOGGLE_STATUS: (state, action) => ({ ...state, is_instant_accept_nurse_enable: action.payload }),
		SET_IS_LOADING_REQUIREMENT: (state, action) => ({ ...state, isLoadingRequirement: action.payload }),
		SET_IS_NEW_SUSPEND_FLOW: (state, action) => ({ ...state, is_new_suspend_flow: action.payload }),
		SET_MEDIATION_COUNT: (state, action) => ({ ...state, mediationCount: action.payload }),
		SET_NURSE_HISTORY_LIST: (state, action) => ({ ...state, nurse_shiftHis: action.payload }),
		SET_NURSE_RATING: (state, action) => ({ ...state, user_rating: action.payload }),
		SET_PASSWORD_TO_VIEWPIN: (state, action) => ({ ...state, passwrdToViewPin: action.payload }),
		SET_PERSONAL_DETAILS_EDIT: (state, action) => ({ ...state, personalDetailsEdit: action.payload }),
		SET_REFERRAL_EMAIL: (state, action) => ({ ...state, referral_email: action.payload }),
		SET_REFERRAL_NAME: (state, action) => ({ ...state, referral_name: action.payload }),
		SET_SUSPEND_END_DATE: (state, action) => ({ ...state, suspendEndDate: action.payload }),
		SET_SUSPEND_END_TIME: (state, action) => ({ ...state, suspendEndTime: action.payload.toString() }),
		SET_THE_BEAT_TOGGLE_STATUS: (state, action) => ({ ...state, isTheBeatUserEnable: action.payload }),
		SET_USER_CARE_SETTING: (state, action) => ({ ...state, user_care_settings: action.payload }),
		SET_USER_CLINICAL_LICENSES: (state, action) => ({ ...state, user_clinical_lisences: action.payload }),
		SET_USER_DNR_LIST: (state, action) => ({ ...state, dnrList: action.payload }),
		SET_USER_PREFER_STATUS: (state, action) => ({ ...state, user_preference_status: action.payload }),
		SET_UTM_SOURCE: (state, action) => ({ ...state, utm_source: action.payload })
	},
	initialState
);

export const createUserInstance = () =>
	function (dispatch, getState) {
		const { newPassword, confirmPassword } = getState().globalUser;
		if (!newPassword.length) {
			return toastr.error('Password is a required field');
		}
		if (newPassword !== confirmPassword) {
			return toastr.error('Passwords do not match');
		}

		// Fix for removing persisted nurse specific details like role
		if (getState().globalUser.type !== '3') {
			dispatch(setGlobalUserRole(''));
			dispatch(setGlobalYearsOfExperience(null));
		}

		Agent.createUserInstance(getState().globalUser).then((response) => {
			if (response.ok) {
				dispatch(resetGlobalUser());
				history.push(`/admin/users/${response.data.id}/edit`);
			} else {
				alert(`User creation failed: ${response.data === null ? 'something went wrong' : response.data}`);
				dispatch(handleError(response));
			}
		});
	};

export const fetchUserDetials = (id) =>
	function (dispatch) {
		Agent.getUserInfoById(id).then((response) => {
			if (response.ok) {
				dispatch(setGlobalUserID(response.data.id));
				dispatch(setUserCareSetting(response.data.user_care_settings));
				dispatch(setGlobalUnitCustomerID(response.data.unit_customer_id));
				dispatch(setAccountRating(response.data.user_rating));
				dispatch(setGlobalUserFullName(response.data.fullname != null ? response.data.fullname : ''));
				dispatch(setGlobalUserFirstName(response.data.first_name != null ? response.data.first_name : ''));
				dispatch(setGlobalUserLastName(response.data.last_name != null ? response.data.last_name : ''));
				dispatch(setGlobalUserNewInc(response.data.shift_bonus_level != null ? response.data.shift_bonus_level : ''));
				dispatch(setGlobalUserEmail(response.data.email != null ? response.data.email : ''));
				dispatch(setGlobalUserAddres(response.data.address != null ? response.data.address : ''));
				dispatch(
					setGlobalUserAddress2(response.data.additional_address != null ? response.data.additional_address : '')
				);
				dispatch(setGlobalUserCity(response.data.city != null ? response.data.city : ''));
				dispatch(setGlobalUserState(response.data.state != null ? response.data.state : ''));
				dispatch(setGlobalUserZipcode(response.data.zip != null ? response.data.zip : ''));
				dispatch(setGlobalUserPrimaryPhone(response.data.phone != null ? response.data.phone : ''));
				dispatch(setGlobalUserAlternatePhone(response.data.alt_phone != null ? response.data.alt_phone : ''));
				dispatch(setGlobalUserNote(response.data.user_notes != null ? response.data.user_notes : ''));
				dispatch(setGlobalUserProfileFileType(response.data.file_type != null ? response.data.file_type : ''));
				dispatch(setGlobalUserProfileImgPath(response.data.photo_location != null ? response.data.photo_location : ''));
				dispatch(setGlobalUserIsAdmin(response.data.admin != null ? response.data.admin : ''));
				dispatch(setGlobalUserIsSupervisor(response.data.supervisor != null ? response.data.supervisor : ''));
				dispatch(setGlobalUserIsShiftManager(!!response.data.shift_manager));
				dispatch(setGlobalUserIsRateIncrease(!!response.data.rate_increase));
				dispatch(setGlobalUserIsNurse(response.data.nurse != null ? response.data.nurse : ''));
				dispatch(setGlobalUserStatus(response.data.status != null ? response.data.status : ''));
				dispatch(setGlobalUserOrgs(response.data.user_orgs != null ? response.data.user_orgs : []));
				dispatch(
					setGlobalUserRole(
						response.data.role_id != null ? (response.data.role_id > 0 ? response.data.role_id : '') : ''
					)
				);
				dispatch(
					setGlobalUserResumeFile(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_location : '')
				);
				dispatch(
					setGlobalYearsOfExperience(
						response.data.years_of_experience !== null ? response.data.years_of_experience.toString() : ''
					)
				);
				dispatch(
					setGlobalYearsOfExperienceID(
						response.data.years_of_experience_id !== null ? response.data.years_of_experience_id.toString() : ''
					)
				);
				dispatch(setGlobalUserIsTestUser(response.data.is_test_user != null ? response.data.is_test_user : ''));
				dispatch(
					setGlobalUserResumeFileName(
						response.data.user_resumes[0] ? response.data.user_resumes[0].resume_file_name : ''
					)
				);
				dispatch(setGlobalUserResumeFileId(response.data.user_resumes[0] ? response.data.user_resumes[0].id : -1));
				dispatch(setGlobalUserFormState(true));
				dispatch(setuserPreferenceStatus(response.data.preferences[0] ? response.data.preferences[0].status : false));
				dispatch(setMediationCount(response.data.mediation_count != null ? response.data.mediation_count : 0));
				dispatch(
					setCompltShiftCount(response.data.completed_shift_count != null ? response.data.completed_shift_count : 0)
				);
				dispatch(setGlobalUserDetail(response.data));
				dispatch(setGlobalUserAcceptCount(response.data.shift_count_info.count_accepts));
				dispatch(setGlobalUserAcceptYearlyCount(response.data.shift_count_info.accepted));
				dispatch(setGlobalUserCalloutCount(response.data.shift_count_info.count_callouts));
				dispatch(setGlobalUserCalloutRate(response.data.shift_count_info.callout_rate));
				dispatch(setGlobalUserCalloutYearlyCount(response.data.shift_count_info.callout));
				dispatch(setGlobalUserWorkedYearlyCount(response.data.shift_count_info.worked));
				dispatch(setGlobalUserNCNSCalloutCount(response.data.shift_count_info.count_ncnscallouts));
				dispatch(setGlobalUserNCNSYearlyCount(response.data.shift_count_info.ncns));
				dispatch(setGlobalUserActivatedOn(response.data.activated_on));
				dispatch(setGlobalUserExcusedCalloutCount(response.data.shift_count_info.count_excusedcallouts));
				dispatch(setGlobalUserEightHoursCalloutCount(response.data.shift_count_info.count_beforeeightcallouts));
				dispatch(
					setGlobalUserSTATCashStatus(
						response.data.statcash_status_info.latest_statcash_status
							? response.data.statcash_status_info.latest_statcash_status
							: 4
					)
				);
				dispatch(setGlobalUserIsAboveGold(response.data.loyalty_level_id));
				dispatch(setGlobalUserIsAboveSilver(response.data.loyalty_level_id));
				dispatch(setIsNewSuspendFlow(response.data.is_new_suspend_flow));
				dispatch(setDefaultSuspendDate(response.data.default_suspension_end));
				dispatch(setDefaultSuspendStartDate(response.data.default_suspension_start));
				dispatch(setCurrentStartTime(response.data.current_suspension_start));
				dispatch(setCurrentEndTime(response.data.current_suspension_end));
				dispatch(setUserClinicalLisences(response.data.clinical_liscences));
				dispatch(setNurseInstantAcceptToggleStatus(response.data.is_instant_accept_nurse_enable));
				dispatch(setTheBeatUserToggleStatus(response.data.beat_user_preferences));
				dispatch(setBeatAdminToggleStatus(response.data.is_beat_admin));
				dispatch(setGlobalUserReferralName(response.data.referral_name ? response.data.referral_name : ''));
				dispatch(setGlobalUserReferralEmail(response.data.referral_email ? response.data.referral_email : ''));
				dispatch(setGlobalUserUTMSource(response.data.utm_source ? response.data.utm_source : ''));
				dispatch(setGlobalUserEmergencyContactName(response.data.emergency_contact_name));
				dispatch(setGlobalUserEmergencyContactPhone(response.data.emergency_contact_phone));
				dispatch(setGlobalUserEmergencyContactReleationship(response.data.emergency_contact_relationship));

				dispatch(setGlobalUserNursePool(response.data.nurse_pool_type));
			} else {
				history.push('/admin/users');
				dispatch(handleError(response));
			}
		});
	};

export const updateUserSTATCashInfo = (statcash_status_id) =>
	function (dispatch) {
		dispatch(setGlobalUserSTATCashStatus(statcash_status_id));
	};

export const fetchUserOrgList = (id) =>
	function (dispatch) {
		Agent.getUserInfoById(id).then((response) => {
			if (response.ok) {
				dispatch(setGlobalUserOrgs(response.data.user_orgs != null ? response.data.user_orgs : []));
			} else {
				history.push('/admin/users');
			}
		});
	};

export const updateUserInfo = () =>
	function (dispatch, getState) {
		const { newPassword, confirmPassword } = getState().globalUser;
		if (newPassword !== confirmPassword) {
			alert('Passwords do not match');
			return;
		}

		Agent.updateUserInfo(getState().globalUser).then((response) => {
			if (response.ok) {
				dispatch(setGlobalUserFormState(true));
				if (!getState().globalUser.is_supervisor) {
					dispatch(setAddUserAutoGenerateCode(Math.floor(1000 + Math.random() * 9000).toString()));
				}
				// To get updated security code value.
				// As before updating user info security code value was null for nurse and admin users.
				dispatch(fetchUserDetials(getState().globalUser.user_id));

				alert('User information successfully updated.');
				dispatch(setPersonalDetailsEdit(false));
			} else {
				alert(response.data);
				dispatch(setPersonalDetailsEdit(true));
			}
		});
	};

export const uploadUserProfileImage = (file, userID = '') =>
	function (dispatch) {
		if (file) {
			dispatch(setGlobalUserDisplay('block'));
			const uploadPromise = !!userID ? Agent.uploadFileOnS3UserProfile(file, userID) : Agent.uploadFileOnS3(file);
			uploadPromise.then((response) => {
				if (response.ok) {
					dispatch(setGlobalUserProfileImgPath(response.data.path));
					dispatch(setGlobalUserProfileFileType(response.data.content_type));
				} else {
					alert('Failed to upload user image. Please check you file type and file size.');
				}
				dispatch(setGlobalUserDisplay('none'));
			});
		}
	};

export const fetchUserRequirements = () =>
	function (dispatch, getState) {
		Agent.getUserRequirements(getState().globalUser.user_id).then((response) => {
			if (response.ok) {
				dispatch(setGlobalUserRequirements(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const fetchUserRequirementToUpdate = (req_id) =>
	function (dispatch, getState) {
		dispatch(setIsLoadingRequirement(true));
		Agent.getUserRequirementToUpdate(getState().globalUser.user_id, req_id).then((response) => {
			dispatch(setIsLoadingRequirement(false));
			if (response.ok) {
				dispatch(setGlobalUserReqDetails(response.data));
			}
		});
	};

export const fetchDecryptedRequirement = (user_req_id) =>
	function (dispatch, getState) {
		dispatch(setIsLoadingRequirement(true));
		Agent.getDecryptedUserRequirement(getState().globalUser.user_id, user_req_id).then((response) => {
			dispatch(setIsLoadingRequirement(false));
			if (response.ok) {
				dispatch(setGlobalUserReqDetails(response.data));
			}
		});
	};

export const fetchUserRequirementToAdd = (req_id) =>
	function (dispatch) {
		dispatch(setIsLoadingRequirement(true));
		Agent.getUserRequirementToAdd(req_id).then((response) => {
			dispatch(setIsLoadingRequirement(false));
			if (response.ok) {
				dispatch(setGlobalUserReqDetails(response.data));
			}
		});
	};

export const getSearchRequirementList = (stext) =>
	function (dispatch, getState) {
		let search_text = stext;
		if (stext === '' || stext == undefined) {
			const { str } = getState().requirement;
			search_text = str;

			if (search_text === '' || search_text == undefined) {
				search_text = undefined;
			}
		}

		Agent.searchUserRequirement(search_text).then((response) => {
			if (response.ok) {
				dispatch(setRequirementsSearchList(response.data));
			}
		});
	};

export const deleteUserRequirements = (user_req_id) =>
	function (dispatch, getState) {
		Agent.deleteUserRequirement(user_req_id, getState().globalUser.user_id).then((response) => {
			if (response.ok) {
				dispatch(fetchUserRequirements());
			}
		});
	};

export const changeRequirementApproveState = (req_id, state) =>
	function (dispatch, getState) {
		Agent.changeRequirementApproveState(getState().globalUser.user_id, parseInt(req_id), state).then((response) => {
			if (response.ok) {
				dispatch(fetchUserRequirements());
			}
		});
	};

export const uploadResumeFile = (file) =>
	function (dispatch, getState) {
		if (file) {
			dispatch(setGlobalUserResumeFile(''));
			dispatch(setGlobalUserResumeDisplay('block'));
			dispatch(setGlobalUserResumeDisplayMsg(''));
			Agent.uploadResume(file, getState().globalUser.user_id).then((response) => {
				if (response.ok) {
					dispatch(setGlobalUserResumeDisplay('none'));
					dispatch(setGlobalUserResumeFile(response.data.path));
					dispatch(setGlobalUserResumeFileName(file.name));
					dispatch(setGlobalUserResumeFileId(response.data.id));
					dispatch(setGlobalUserResumeDisplayMsg('Successfully uploaded Resume'));
				} else {
					dispatch(setGlobalUserResumeDisplay('none'));
					alert('Failed to upload user image. Please check you file type and file size.');
				}
			});
		}
	};

export const fetchUserJobHistories = () =>
	function (dispatch, getState) {
		Agent.getUserJobHistories(getState().globalUser.user_id).then((response) => {
			if (response.ok) {
				dispatch(setGlobalUserJobHistories(response.data.job_history));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const createUserJobHistory = (formObj) =>
	function (dispatch, getState) {
		Agent.createUserJobHistory(
			parseInt(getState().globalUser.user_id),
			formatDate.clientDateToYyMmDd(formObj.start_date),
			formObj.end_date != null ? formatDate.clientDateToYyMmDd(formObj.end_date) : null,
			formObj.title,
			formObj.company,
			formObj.city,
			formObj.state,
			formObj.description
		).then((response) => {
			if (response.ok) {
				dispatch(fetchUserJobHistories());
			} else {
				alert(`Job history creation failed: ${response.data === null ? 'something went wrong' : response.data}`);
			}
		});
	};

export const deleteUserJobHistory = (id) =>
	function (dispatch) {
		Agent.deleteUserJobHistory(parseInt(id)).then((response) => {
			if (response.ok) {
				dispatch(fetchUserJobHistories());
			}
		});
	};

export const updateUserJobHistoryByAdmin = (id, formObj) =>
	function (dispatch, getState) {
		Agent.updateUserJobHistoryByAdmin(
			parseInt(id),
			parseInt(getState().globalUser.user_id),
			formatDate.clientDateToYyMmDd(formObj.start_date),
			formObj.end_date != null ? formatDate.clientDateToYyMmDd(formObj.end_date) : null,
			formObj.title,
			formObj.company,
			formObj.city,
			formObj.state,
			formObj.description
		).then((response) => {
			if (response.ok) {
				dispatch(fetchUserJobHistories());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getNurseShiftHistory = (props = null) =>
	function (dispatch, getState) {
		dispatch(setFetchingShiftHistory(true));
		Agent.getNurseShiftHistory(getState().globalUser.user_id, props).then((response) => {
			if (response.ok) {
				dispatch(setNurseHistoryList(response.data));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setFetchingShiftHistory(false));
		});
	};

export const clearAcceptedAndAppliedShifts = () =>
	function (dispatch) {
		dispatch(setAcceptedAppliedShifts({}));
	};

export const getAcceptedNApplied = () =>
	function (dispatch, getState) {
		const { suspendEndDate, suspendEndTime, user_id, default_suspend_start_date } = getState().globalUser;
		Agent.getEditUsershiftList(user_id, suspendEndDate, suspendEndTime, default_suspend_start_date).then((response) => {
			if (response.ok) {
				dispatch(setAcceptedAppliedShifts(response.data));
			}
		});
	};

export const updateSecurityCode = (newPincode) =>
	function (dispatch, getState) {
		const { userOrgs } = getState().globalUser;
		const org_id = userOrgs[0].organization_id;
		const oldPinCode = userOrgs[0].security_code;

		Agent.updateSecurityCodeByAdmin(org_id, oldPinCode, parseInt(newPincode), getState().globalUser.user_id).then(
			(response) => {
				if (response.ok) {
					dispatch(setAutoGeneratedPinPopup(false));
					dispatch(fetchUserDetials(getState().globalUser.user_id));
				} else {
					alert(`Error:${response.data}`);
				}
			}
		);
	};

export const updateDefaultSuspensionStartAndEnd = () =>
	function (dispatch) {
		dispatch(
			setDefaultSuspendDate(
				moment(this.state.suspendEndDate).format('YYYY-MM-DD') + moment(this.state.suspendEndTime).format('HH:MM:SS')
			)
		);
	};

export const updateCurrentSuspensionStartAndEnd = (start_date, end_date) =>
	function (dispatch) {
		dispatch(setCurrentStartTime(start_date));
		dispatch(setCurrentEndTime(end_date));
	};

export const getUserDNRList = (nurseId) => (dispatch) => {
	dispatch(setUserDNRList({}));
	Agent.getDnrList(1, '', '', '', nurseId).then((response) => {
		if (response.ok) {
			dispatch(setUserDNRList(response.data));
		} else {
			dispatch(handleError(response));
		}
	});
};
export const updateNurseInstantAcceptStatus = (status) =>
	function (dispatch, getState) {
		const { user_id } = getState().globalUser;
		Agent.updateNurseFeatureByName(user_id, constants.instantAcceptNurse, status).then((response) => {
			if (response.ok) {
				dispatch(setNurseInstantAcceptToggleStatus(status));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const updateTheBeatUserStatus = (status) =>
	function (dispatch, getState) {
		const { user_id } = getState().globalUser;
		Agent.updateNurseFeatureByName(user_id, constants.theBeatUser, status).then((response) => {
			if (response.ok) {
				dispatch(setTheBeatUserToggleStatus(status));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const updateBeatAdminStatus = (status) =>
	function (dispatch, getState) {
		const { user_id } = getState().globalUser;
		Agent.updateUserBeatAdmin(user_id, status).then((response) => {
			if (response.ok) {
				dispatch(setBeatAdminToggleStatus(status));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const updateShiftManagerStatus = (status) => (dispatch, getState) => {
	const { user_id } = getState().globalUser;
	Agent.updateNurseFeatureByName(user_id, constants.SHIFT_MANAGER_SUPERVISOR, status).then((response) => {
		if (response.ok) {
			dispatch(setGlobalUserIsShiftManager(status));
		} else {
			dispatch(handleError(response));
		}
	});
};

export const updateRateIncreaseStatus = (status) => (dispatch, getState) => {
	const { user_id } = getState().globalUser;
	Agent.updateNurseFeatureByName(user_id, constants.RATE_INCREASE_SUPERVISOR, status).then((response) => {
		if (response.ok) {
			dispatch(setGlobalUserIsRateIncrease(status));
		} else {
			dispatch(handleError(response));
		}
	});
};
